import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
            {aboutData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-10 max-w-3xl mx-auto">
            {aboutData.content}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {aboutData.highlights.map((item) => (
              <div
                key={item.label}
                className="bg-background-50 rounded-lg p-6 border border-background-200/70"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg mx-auto mb-4">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-base text-foreground-950 mb-2">{item.label}</h3>
                <p className="text-sm text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}